import React, { Component, Fragment } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleButton from "../../../modules/commons/SimpleButton";
import * as R from "ramda";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment/moment";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../Services/Api";
import { mapToObjectDDL } from "../../common/mapper";

class ManagementNRFSFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusOption: [],
      dataVariant: [],
      dataWarna: [],
      dataLocator: [],
      statusOption: [
        {
          label: "RFS",
          value: "RFS",
        },
        {
          label: "NRFS",
          value: "NRFS",
        },
      ],
    };
  }

  componentDidMount = async () => {
    this.fetchDataVarian();
    this.fetchDataWarna();
    this.fetchDataLocator();
  };

  fetchDataVarian = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataVariant: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataWarna = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarna({
        distinct: true,
      });
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataWarna: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleInputDateChange = (name, value) => {
    let parseValue = M(value).format("DD-MM-YYYY");
    this.props.onValueChange(name, parseValue);
  };

  render() {
    return (
      <Fragment>
        <SimpleModal
          title="Filter"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          styles={{
            width: "40%",
          }}
          content={
            <ModalContainer>
              <SimpleInput
                id="input_text_no_rangka"
                name="nomorRangka"
                label="Nomor Rangka"
                value={this.props.filterData.nomorRangka}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleInput
                id="input_text_no_mesin"
                name="nomorMesin"
                label="Nomor Mesin"
                value={this.props.filterData.nomorMesin}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleDDL
                id="select_options_varian"
                name="kodeVarian"
                box="search"
                label="Nama Varian"
                options={this.state.dataVariant.map((item) =>
                  mapToObjectDDL(item.namaVariant, item.kodeVariant)
                )}
                value={this.props.filterData.kodeVarian}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <SimpleDDL
                id="select_options_nama_warna"
                name="kodeWarna"
                box="search"
                label="Nama Warna"
                options={this.state.dataWarna.map((item) =>
                  mapToObjectDDL(item.namaWarnaKomersil, item.kodeWarna)
                )}
                value={this.props.filterData.kodeWarna}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <SimpleInput
                id="input_text_tahun_produksi"
                name="tahunProduksi"
                label="Tahun Produksi"
                value={this.props.filterData.tahunProduksi}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleDDL
                id="select_options_locator"
                name="kodeLocator"
                label="Locator"
                box="search"
                options={this.state.dataLocator.map((item) =>
                  mapToObjectDDL(item.nameLocation, item.kodeLocation)
                )}
                value={this.props.filterData.kodeLocator}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <SimpleDDL
                id="select_options_status"
                name="statusRFS"
                label="Status"
                box="search"
                options={this.state.statusOption}
                value={this.props.filterData.statusRFS}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <div style={{ textAlign: "right", marginTop: 20 }}>
                <SimpleButton
                  type="button"
                  text="Hapus"
                  onClick={() => this.props.onClearFilter()}
                />
                <SimpleButton
                  type="button"
                  text="Terapkan"
                    onClick={() => this.props.onSubmit()}
                />
              </div>
            </ModalContainer>
          }
        />

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default ManagementNRFSFilter;
